import * as React from 'react';
import styled from "styled-components";
import Assets from "../../../assets/img/assets";
import HeadlineLarge from "../../../common/atom/text/headline_large";
import {ConstBreakPoint} from "../../../../config/styles_const/styles_const";

interface IProps {
}

const AuthApplyClientRegisterSide: React.FC<IProps> = (props) => {
    const {  } = props;

    return (
        <Wrapper>
            <CreateFormTitle>
                法人向け新規登録
            </CreateFormTitle>
            <CreateFormImgCenterWrapper>
                <CreateFormImg src={Assets.apply_client} />
            </CreateFormImgCenterWrapper>
        </Wrapper>
    )

};

export default AuthApplyClientRegisterSide;

const Wrapper = styled.div`
    @media screen and (min-width: ${ConstBreakPoint.Default}) {
        margin-right: 20px;
        width: 50%;
    }   
`;

const CreateFormImgCenterWrapper = styled.div`
    @media screen and (min-width: ${ConstBreakPoint.Default}) {
        height: 70%;
        display: flex;
        flex-direction: column;
        flex-wrap: wrap;
        justify-content: center;
        align-items: center;
    }
`;

const CreateFormTitle = styled(HeadlineLarge)`
    text-align: center;
    margin-bottom: 30px;
    @media screen and (min-width: ${ConstBreakPoint.Default}) {
        text-align: left;
        margin-bottom: 0;
    }    
`;

const CreateFormImg = styled.img`
    margin-bottom: 30px;    
`;


// WEBPACK FOOTER //
// ./src/presentation/component/auth/apply_client_register/auth_apply_client_register_side.tsx